import {
  infiniteQueryOptions,
  queryOptions,
  useMutation,
  useQueryClient,
} from "@tanstack/react-query";
import {
  createFileDuplication,
  retrieveFileDuplication,
} from "@/lib/data/requests/files/file-duplication";
import { isFileDuplicationFinished } from "@/lib/data/schemas/file-duplication";
import { queryKeys } from "@/lib/data/static/query-keys";

export const fileDuplicationQueryOptions = (id: string, enabled = true) =>
  queryOptions({
    queryKey: [queryKeys.fileDuplications, id],
    queryFn: () => retrieveFileDuplication(id),
    enabled: enabled && !!id,
    refetchInterval: (query) =>
      query.state.data && isFileDuplicationFinished(query.state.data.status)
        ? false
        : 2000,
  });

export const fileDuplicationItemsQueryOptions = (id: string, enabled = true) =>
  infiniteQueryOptions({
    queryKey: [queryKeys.fileDuplications, id, "items"],
    initialPageParam: undefined as string | undefined,
    queryFn: ({ pageParam }) => retrieveFileDuplication(id, pageParam),
    getNextPageParam: (page) => page.nextCursor ?? undefined,
    enabled: enabled && !!id,
  });

export const useCreateFileDuplication = () => {
  const client = useQueryClient();
  return useMutation({
    mutationFn: createFileDuplication,
    onSuccess: (operation) => {
      client.setQueryData(
        [queryKeys.fileDuplications, operation.id],
        operation,
      );
    },
  });
};
